import React, { useState, useEffect } from "react";
import styles from "./slideshow.module.css";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";

import LanguageContext from "../../context/context";

const SlideShow = ({ slides }) => {
  const [slideIndex, setSlideIndex] = useState(1);
  const [second, setSecond] = useState(1)

  useEffect(() => {
    setTimeout(() => {
      setSecond(seconds => seconds + 1)
    }, 1000)

    if (second % 5 === 0) nextSlide()
  }, [second, nextSlide])

  const nextSlide = () => {
    if (slideIndex !== slides.length) {
      setSlideIndex(slideIndex + 1);
    } else if (slideIndex === slides.length) {
      setSlideIndex(1);
    }
  };

  const prevSlide = () => {
    if (slideIndex !== 1) {
      setSlideIndex(slideIndex - 1);
    } else if (slideIndex === 1) {
      setSlideIndex(slides.length);
    }
  };

  const clickHandler = () => {

// javascript:void(Tawk_API.toggle()) in anchor tag
        if (window.Tawk_API) window.Tawk_API.maximize()
  }

  return (
    <section className={styles.container}>
      <LanguageContext.Consumer>
        {({ language }) => {
          return (
            <a className={`${styles.button}`} href="https://wa.me/995593326928">{language === "en" ? "BOOK NOW" : "ЗАКАЗАТЬ СЕЙЧАС"}</a>
          );
        }}
      </LanguageContext.Consumer>
      <FaArrowLeft className={styles.left_arrow} onClick={prevSlide} />
      <FaArrowRight className={styles.right_arrow} onClick={nextSlide} />
      {slides.map((slide, index) => {
        return (
          <div
            key={index}
            className={`${slideIndex === index + 1 ? styles.active : styles.slide
              }`}
          >
            <img className={styles.image} src={slide} alt="Hotel Heyvany" />
          </div>
        );
      })}
    </section>
  );
};

export default SlideShow;
